import { format } from "date-fns";

import { XIcon } from "@/assets/X";
import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import { cn } from "@/lib/utils";
import { INotification } from "../types/Notification";

type Props = {
  notification: INotification | null;
  /**
   * Было ли уведомление непрочитанным в момент открытия. Само оно к этому
   * моменту уже помечено прочитанным (по ТЗ — при нажатии), а маркер в
   * шторке показываем именно по состоянию на момент открытия.
   */
  wasUnread: boolean;
  onClose: () => void;
};

/**
 * Шторка уведомления по тапу на карточку: крестик, картинка (или пустая
 * плашка, если её нет), дата, заголовок с точкой непрочитанного и текст.
 */
export const NotificationDrawer = ({
  notification,
  wasUnread,
  onClose,
}: Props) => (
  <Drawer
    shouldScaleBackground={false}
    open={Boolean(notification)}
    onOpenChange={(open) => {
      if (!open) onClose();
    }}
  >
    <DrawerContent
      handleClassName="hidden"
      // Высота фиксированная — 80% экрана при любом тексте, как в макете;
      // длинный текст скроллится внутри.
      className="h-[80dvh] max-h-[80dvh] bg-fill-background px-4 pb-safe-bottom pt-4"
    >
      {notification && (
        <div className="flex flex-col gap-4 pb-6">
          <div className="flex flex-row justify-end">
            <button
              type="button"
              onClick={onClose}
              className="flex h-6 w-6 items-center justify-center rounded-full bg-button-secondary"
            >
              <XIcon className="text-text-icon-secondary" />
            </button>
          </div>
          {/* Картинка из макета 343×200 на ширине 375: по ширине — вся
              строка между отступами, высота — из пропорции, чтобы на любом
              экране оставаться той же формы. Без картинки блока нет. */}
          {notification.image && (
            <div className="aspect-[343/200] w-full overflow-hidden rounded-2xl bg-white">
              <img
                src={notification.image}
                alt=""
                className="h-full w-full object-cover"
              />
            </div>
          )}
          <div className="flex flex-col gap-1">
            <p className="text-caption-sm-medium text-text-tertiary">
              {format(new Date(notification.createdAt), "dd.MM.yyyy HH:mm")}
            </p>
            <div className="flex flex-row items-center gap-2">
              <span
                className={cn(
                  "h-2 w-2 shrink-0 rounded-full bg-fill-danger",
                  !wasUnread && "hidden",
                )}
              />
              <DrawerTitle className="min-w-0 break-words text-display-md text-text-primary">
                {notification.title}
              </DrawerTitle>
            </div>
          </div>
          <p className="whitespace-pre-line break-words text-body-sm-regular text-text-secondary">
            {notification.description}
          </p>
        </div>
      )}
    </DrawerContent>
  </Drawer>
);
